// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5030abf5","254":"c2717fd3","513":"9d443b0d","557":"3141b332","649":"64c472a7","703":"95a6f5a3","732":"89e2425b","787":"9647d828","825":"bac0794c"}[chunkId] + ".chunk.js";
};